import instance from '.'
import { err, getResult } from 'src/utils/functions'
import { APIResult } from 'src/utils/types'

export type AdminListReport = {
  id: number
  contentType: 'list' | 'poll'
  listId?: number | null
  pollId?: number | null
  contentId?: number | null
  reportedByUserId?: number | null
  reportedByUsername?: string | null
  creatorId?: number | null
  creatorUsername?: string | null
  title?: string | null
  visibility?: string | null
  items?: string[]
  reason: string
  details?: string | null
  status: 'open' | 'under_review' | 'resolved' | 'dismissed'
  resolutionAction?: string | null
  resolutionNote?: string | null
  listPrompt?: string | null
  listCreatorId?: number | null
  listVisibilityStatus?: 'active' | 'hidden' | 'removed' | null
  createdAt: string
  updatedAt?: string
}

type ResolveReportInput = {
  reportId: number
  status: 'resolved'
  resolutionAction?: 'none' | 'hide' | 'delete' | 'block' | 'accept'
}

export type AdminReportsResult = {
  rows: AdminListReport[]
  total: number
  page: number
  limit: number
}

export type BannedUserRow = {
  id: number
  username: string
  email: string
  role: string
  canCreateLists: boolean
  createdAt: string
}

export async function getAdminReports(
  status: 'open' | 'resolved' | 'all' = 'open',
  limit = 20,
  page = 0
): Promise<APIResult<AdminReportsResult>> {
  return instance
    .get('/api/admin/reports', {
      params: { status, limit, page },
    })
    .catch((e) => err(e))
    .then((res) => getResult<AdminReportsResult>(res))
}

export async function getBannedUsers(): Promise<APIResult<BannedUserRow[]>> {
  return instance
    .get('/api/admin/users/banned')
    .catch((e) => err(e))
    .then((res) => getResult<BannedUserRow[]>(res))
}

export async function resolveAdminReport(input: ResolveReportInput): Promise<APIResult<void>> {
  return instance
    .post(`/api/admin/reports/${input.reportId}/resolve`, {
      status: input.status,
      resolutionAction: input.resolutionAction || 'none',
    })
    .catch((e) => err(e))
    .then((res) => getResult<void>(res))
}

export async function setUserListCreatePermission(
  userId: number,
  canCreateLists: boolean
): Promise<APIResult<void>> {
  return instance
    .post(`/api/admin/users/${userId}/list-create-permission`, {
      canCreateLists,
    })
    .catch((e) => err(e))
    .then((res) => getResult<void>(res))
}

export async function updateListVisibilityAdmin(params: {
  listId: number
  visibilityStatus: 'active' | 'hidden' | 'removed'
  moderationReason?: string
}): Promise<APIResult<void>> {
  return instance
    .post(`/api/admin/lists/${params.listId}/visibility`, params)
    .catch((e) => err(e))
    .then((res) => getResult<void>(res))
}
